var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-alarm",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.$refs.filialsettingspopover.$emit("close")
        },
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "c-alarm-button",
          attrs: { id: `position-alarm-${_vm.postCode}-${_vm.cellIndex}` },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "2",
                height: "13",
                viewBox: "0 0 2 13",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1 1L1 7M1 11L1 12",
                  stroke: "#c91512",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _vm.postCode !== "driver" && Number(_vm.countWorkers) > 0
        ? _c(
            "b-popover",
            {
              ref: "filialsettingspopover",
              attrs: {
                id: "position-alarm-popover",
                placement: "bottomright",
                triggers: "click blur hover",
                target: `position-alarm-${_vm.postCode}-${_vm.cellIndex}`,
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "b-popover-warning",
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("circle", {
                    attrs: {
                      cx: "7",
                      cy: "7",
                      r: "6.5",
                      fill: "white",
                      stroke: "#FF238D",
                    },
                  }),
                  _c("circle", {
                    attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                  }),
                  _c("rect", {
                    attrs: {
                      x: "6",
                      y: "3",
                      width: "2",
                      height: "5",
                      rx: "1",
                      fill: "#FF238D",
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "b-popover-text" }, [
                _c("p", [_vm._v("За должностью закреплены сотрудники.")]),
                _c(
                  "a",
                  {
                    staticClass: "b-popover-text-link",
                    on: {
                      click: function ($event) {
                        return _vm.goToEmployeesTable(_vm.postCode)
                      },
                    },
                  },
                  [_vm._v("Посмотреть связанных сотрудников")]
                ),
              ]),
              _c(
                "svg",
                {
                  staticClass: "b-popover-close",
                  attrs: {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 15 15",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 10.6087C10.2154 10.9977 9.58272 10.9958 9.19126 10.6043L3.53712 4.95155C3.14565 4.56008 3.14367 3.92737 3.5327 3.53835C3.92172 3.14932 4.55443 3.1513 4.9459 3.54277L10.6 9.19551C10.9915 9.58698 10.9935 10.2197 10.6045 10.6087Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 3.54158C10.2212 3.15011 9.58849 3.14813 9.19947 3.53716L3.53718 9.19945C3.14816 9.58847 3.15014 10.2212 3.54161 10.6127C3.93307 11.0041 4.56579 11.0061 4.95481 10.6171L10.6171 4.95478C11.0061 4.56576 11.0041 3.93305 10.6127 3.54158Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }